import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { FaFacebookF } from '@react-icons/all-files/fa/FaFacebookF';
import { FaInstagram } from '@react-icons/all-files/fa/FaInstagram';
import ContactMeForm from './forms/contactMeForm';
import cn from 'classnames';

const Footer = ({ location }) => {
  const { page } = useStaticQuery(query);
  const homePage = location.pathname === '' || location.pathname === '/';

  return (
    <div
      className={cn('mx-4 md:mx-16 flex flex-col space-y-4 lg:space-y-0 lg:flex-row lg:space-x-2 justify-between lg:px-2 xl:px-32 py-6', { 'border-t-2 border-gray-300': !homePage })}>
      <div className='flex flex-col space-y-4 lg:max-w-[30%] xl:max-w-[20%]'>
        <p className='text-3xl'>{page.name}</p>
        <p className='whitespace-pre-wrap'>{page.footerDescription.footerDescription}</p>
        <a href={`mailto:${page.contactEmail}`}
           className='opacity-75 hover:text-primary transition-colors duration-150 duration-150 mr-auto'>{page.contactEmail}</a>
      </div>
      <div className='flex flex-col space-y-2 text-lg opacity-75'>
        <Link to='/om'
              className='transition-colors duration-150 hover:text-primary border-b-2 border-transparent hover:border-primary'>Om
          oss</Link>
        <Link to='/arbetsgivare'
              className='transition-colors duration-150 hover:text-primary border-b-2 border-transparent hover:border-primary'>För
          arbetsgivare</Link>
      </div>
      <div className='flex flex-col space-y-2'>
        {(page.instagramLink || page.facebookLink) &&
        <p className='opacity-75 text-lg'>Social media</p>}
        <div className='flex space-x-4 text-primary'>
          {page.instagramLink && <a href={page.instagramLink}><FaInstagram
            className='w-8 h-8 hover:text-gray-300 transition-colors duration-150' /><span
            className='sr-only'>Instagram</span></a>}
          {page.facebookLink &&
          <a href={page.facebookLink}><FaFacebookF
            className='w-8 h-8 hover:text-gray-300 transition-colors duration-150' /><span
            className='sr-only'>Facebook</span></a>}
        </div>
      </div>
      <div className='flex flex-col space-y-2 items-start lg:max-w-[30%] xl:max-w-[20%]'>
        <p className='text-2xl'>Kontakta oss</p>
        <p>{page.footerContactDescription.footerContactDescription}</p>
        <ContactMeForm />
      </div>
    </div>
  );
};

export default Footer;

const query = graphql`
    query {
        page: contentfulHemsida {
            name
            footerDescription {
                footerDescription
            }
            footerContactDescription {
                footerContactDescription
            }
            instagramLink
            facebookLink
            contactEmail
        }
    }
`;
